import PlanboardMode from './PlanboardMode'
import _ from 'lodash'

export default class PlanboardModeBlock extends PlanboardMode {
  start() {
    this.planboard.$defaultButtons.hide()
    this.planboard.$blockSlotsButtons.show()
  }

  stop() {
    this.planboard.$defaultButtons.show()
    this.planboard.$blockSlotsButtons.hide()
    this.planboard.$elm
      .find('.planboard-slot.selected-block')
      .removeClass('selected-block')
    this.planboard.$activityRows.removeClass('planboard__activity--dimmed')
  }

  finish() {
    var $slots = this.planboard.$elm.find('.planboard-slot.selected-block')

    if (!$slots.length) {
      return
    }

    var slots = $slots.map(function() {
      var $this = $(this)
      return $this.attr('data-start-time') + ' - ' + $this.attr('data-end-time')
    })

    var timestamps = $slots.map(function() {
      var $this = $(this)
      return {
        StartTimeUtc: $this.attr('data-start-time-utc'),
        EndTimeUtc: $this.attr('data-end-time-utc'),
      }
    })

    var data = {
      activityName: $slots
        .first()
        .parents('.planboard__activity')
        .attr('data-activity-name'),
      activityKey: $slots.first().attr('data-activity-key'),
      date: $('#planboard-date-input').val(),
      slots: slots.get(),
      timestamps: timestamps.get(),
    }

    this.planboard.modal(
      $(_.template(window.templates.blockSelectionModal)(data)),
    )
  }

  slotsChanged() {
    var $blockedSlots = this.planboard.$elm.find(
      '.planboard-slot.selected-block',
    )

    if (!$blockedSlots.length) {
      this.planboard.$activityRows.removeClass('planboard__activity--dimmed')
      this.planboard.$blockSelectionButton.prop('disabled', true)
    } else {
      this.planboard.$blockSelectionButton.prop('disabled', false)
    }

    if ($blockedSlots.length == 1) {
      this.planboard.$activityRows
        .removeClass('planboard__activity--dimmed')
        .not(
          '[data-activity-key="' +
            $blockedSlots.attr('data-activity-key') +
            '"]',
        )
        .addClass('planboard__activity--dimmed')
    }
  }

  slotClick($slot) {
    PlanboardMode.prototype.slotClick.call(this, ...arguments)

    if (
      $slot.attr('data-available') !== 'false' &&
      !$slot.parents('.planboard__activity--dimmed').length
    ) {
      $slot.toggleClass('selected-block')
      this.planboard.slotsChanged()
    }
  }
}
